import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHome, FaChartBar, FaExchangeAlt, FaUsers } from 'react-icons/fa';
import './BottomNavigation.css';

const BottomNavigation = ({ activeTab = 'home', onTabChange }) => {
  const { t } = useTranslation();
  
  const navItems = [
    { id: 'home', label: t('nav.home'), icon: <FaHome /> },
    { id: 'serve', label: t('nav.serve'), icon: <FaChartBar /> },
    { id: 'swap', label: t('nav.swap'), icon: <FaExchangeAlt /> },
    { id: 'spread', label: t('nav.spread'), icon: <FaUsers /> },
  ];

  return (
    <nav className="bottom-navigation">
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
          onClick={() => onTabChange && onTabChange(item.id)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavigation;
